<template>
  <div class="g-loading">
    <div class="m-lodingTop">
      <img src="../assets/tongwei/logo.png" alt="" class="u-logo" />
      <img src="../assets/tongwei/logoText.png" alt="" class="u-logoText" />
    </div>
    <div class="m-loadingMain">
      <div class="progress">
        <div class="progress-bar" v-bind:style="{ width: this.random }">
          <div class="animate-bar"></div>
        </div>
      </div>
    </div>

    <div class="m-loadingBottom">
      <img src="../assets/tongwei/logoBottom.png" alt="" class="u-logoBottom">
    </div>
  </div>
</template>

<script>
export default {
  name: "loading",
  props: ["random"],
  computed: {
    gettime: function () {
      // `this` 指向 vm 实例
      let myDate = new Date();
      let time = myDate.toLocaleDateString().split("/").join(".");
      if (this.getQueryString("date") == null) {
        return time;
      } else {
        return this.getQueryString("date").replace(/-/g, ".");
      }
    },
  },
  methods: {
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = decodeURI(window.location.search.substr(1)).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },
  },
  mounted(){
    
  }
};
</script>

<style lang="scss" scoped>
.g-loading {
  position: fixed;
  width: 100%;
  height: 100%;
  background: url(../assets/tongwei/bg.png) no-repeat;
  background-size: 100% 100%;
  z-index: 999;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  top: 0;
  left: 0;
}
.m-lodingTop {
  display: flex;
  padding: 0.533333rem;
  justify-content: space-between;
}
.u-logo {
  width: 2.293333rem;
  height: 0.586667rem;
}
.u-logoText {
  width: 1.986667rem;
  height: 0.506667rem;
}

.progress {
  position: relative;
  width: 6.16rem;
  height: 0.106667rem;
  margin: 0 auto;
  border-radius: 0.106667rem;
  background-color: #fff;
  margin-top: 4.173333rem;
}
.progress .progress-bar {
  position: absolute;
  left: 0;
  top: 0;
  width: 20%;
  height: 0.106667rem;
  border-radius: 0.106667rem;
  background: linear-gradient(270deg, #dc3a1b 0%, #f2a393 100%);
  transition: width 0.5s;
}
.progress .progress-bar .animate-bar {
  position: absolute;
  left: 0;
  top: 0;
  width: 0%;
  height: 0.106667rem;
  border-radius: 0.106667rem;
  opacity: 0;
  background-color: #fff;
  -webkit-animation: progress-active 2s ease-in-out infinite;
  animation: progress-active 2s ease-in-out infinite；;
}
@-webkit-keyframes progress-active {
  0% {
    opacity: 0.3;
    width: 0;
  }
  to {
    opacity: 0;
    width: 100%;
  }
}
@keyframes progress-active {
  0% {
    opacity: 0.3;
    width: 0;
  }
  to {
    opacity: 0;
    width: 100%;
  }
}

.u-loadingTime {
  text-align: center;
  font-size: 0.533333rem;
  color: #fff;
  letter-spacing: 0.133333rem;
}
.u-hide {
  -webkit-animation: hide 2s ease-in-out forwards 1;
  animation: hide 2s ease-in-out forwards 1;
}
@-webkit-keyframes hide {
  0% {
    opacity: 1;
    scale: 1;
  }
  to {
    opacity: 0;
    scale: 1.5;
  }
}
@keyframes hide {
  0% {
    opacity: 1;
    scale: 1;
  }
  to {
    opacity: 0;
    scale: 1.5;
    z-index: 0;
  }
}
.m-loadingMain {
  width: 6.96rem;
  height: 5.64rem;
  background: url(../assets/tongwei/loadingMain.png) no-repeat;
  background-size: 100% 100%;
  align-self: center;
  position: relative;
}
.m-loadingBottom {
  display: flex;
  padding: 0.533333rem  0.533333rem 0.88rem;
  justify-content: space-between;
}
.u-logoBottom {
    width: 8.84rem;
    height: 1.653333rem;
        display: block;
    margin: 0 auto;
  }

</style>